// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__31gt4","title":"Info_title__3F0p0","links":"Info_links__1KjxZ","link":"Info_link__IM41L","logo":"Info_logo__3I_xW"};